export function updateAssets(state, value) {
  state.assets = value
}

export function appendAssets(state, value) {
  state.assets = state.assets.concat(value)
}

export function updateUploadProgress(state, value) {
  state.uploadProgress = value
}